<template>
  <div>
    <PageAllow controller="Shops" action="shopStockOrdersIn" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>

            <v-col>
              <v-tooltip
                v-if="
                  $permission.permissionAllow(
                    'Shops',
                    'shopStockOrdersInExport'
                  ) && shop_id
                "
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="print"
                    class="px-2 me-2 mb-1 float-end"
                    @click.stop="exportExcel()"
                  >
                    <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                    {{ $t("StockOrderIN.export") }}
                  </v-btn>
                </template>
                <span>{{ $t("StockOrderIN.export") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearchPsiShop v-model="shopSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="stock_order_code"
                  v-model="options.stock_order_code"
                  @text="stockInsKeyWord = $event"
                  :label="$t('StockOrderIN.stockInsKeyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="stockInsTypeSelected"
                  clearable
                  :items="$consts.stock_in_order.shopTypes"
                  :label="$t('StockOrderIN.Fields.stock_in_type')"
                >
                </v-select>
              </v-col>
              <!-- 商品编码 -->
              <SearcherKeyword
                ref="material_code"
                v-model="options.material_code"
                @text="materialCode = $event"
                :label="
                  $t('StockOrderIN.DetailFields.material_code') +
                  '/' +
                  $t('StockOrderIN.DetailFields.material_name')
                "
              />
              <!-- 对象名称 -->
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-if="stockInsTypeSelected == 6 || stockInsTypeSelected == 11"
              >
                <SearcherKeyword
                  ref="keyword"
                  v-model="options.keyword"
                  @text="KeyWord = $event"
                  :label="$t('StockOrderIN.Keyword')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.status"
                  :label="$t('StockOrderIN.status.title')"
                  :items="[
                    $consts.stock_in_order.status[1],
                    $consts.stock_in_order.status[2],
                  ]"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherCancelFlgs v-model="options.cancel_flgs" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="stock_ins"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.stock>
            {{ $t("StockOrderIN.Fields.default_stock_name") }}
          </template>
          <template v-slot:item.stock_name="{ item }">
            {{
              item.type == 11
                ? item.supplier_name
                : item.type == 2
                ? item.account_stock_name
                : item.stock_name
            }}
          </template>
          <!-- 出库单编号/创建时间 -->
          <template v-slot:item.stock_order_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.stock_order_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.total_price="{ item }">
            <span>
              {{ item.total_price | formatMoney }}
            </span>
          </template>
          <!-- 状态 -->
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | stockOrderINStatusColor"
              :text-color="item.status | stockOrderINStatusTextColor"
            >
              {{ item.status | stockOrderINStatusText }}
              <!-- <span
                v-if="
                  item.third_return && item.third_return.push_platform == 1010
                "
              >
                ({{ item.third_return.status | stockOrderOUTThirdStatusText }})
              </span> -->
            </v-chip>
            <br />
            <v-chip
              v-if="item.cancel_flg"
              x-small
              label
              outlined
              color="danger"
            >
              {{ $t("CRUD.cancelled") }}
            </v-chip>
          </template>
          <!-- 完成时间 -->
          <template v-slot:item.finish_time="{ item }">
            {{ item.finish_time | formatTime }}
          </template>
          <template v-slot:item.actions="{ item }">
            <StockOrderInActions
              :stock_in="item"
              :shop_id="shop_id"
              showView
              showExport
              :status="item.status"
              @done="getStockInsFromAPI()"
            />
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import StockOrderInActions from "./plugins/Actions";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherCancelFlgs from "@/components/plugins/SearcherCancelFlgs";
import Shops from "@/api/shops";
import SearchPsiShop from "@/components/plugins/SearchPsiShop";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  stock_order_code: "",
  material_code: "",
  status: [2],
  cancel_flgs: [0],
  type: null,
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    StockOrderInActions,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherStatus,
    SearcherCancelFlgs,
    SearchPsiShop,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.shopPsi"),
          disabled: false,
          href: "/shop-psi",
        },
        {
          text: i18n.t("Nav.shopStockOrdersIn"),
          disabled: true,
          href: "/shop-stock-orders-in",
        },
      ];
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("StockOrderOUT.Fields.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("StockOrderOUT.Fields.actual_time"),
      },
    ],
    headers() {
      let headers = [
        {
          text:
            i18n.t("StockOrderIN.Fields.stock_in_code") +
            " / " +
            i18n.t("StockOrderIN.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
      ];
      headers.push(
        {
          text: i18n.t("StockOrderIN.Fields.stock_out_obj_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "stock_name",
        },
        {
          text: i18n.t("StockOrderIN.Fields.stock_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "stock",
        },
        {
          text: i18n.t("StockOrderIN.Fields.stock_in_type"),
          align: "start",
          sortable: false,
          value: "in_type_str",
        },
        {
          text: i18n.t("StockOrderIN.Fields.detail_count"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "detail_count",
        },
        {
          text: i18n.t("StockOrderIN.Fields.total_price"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "total_price",
        },
        {
          text: i18n.t("StockOrderIN.Fields.status"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("StockOrderIN.Fields.finish_time"),
          align: "start",
          sortable: false,
          value: "finish_time",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        }
      );
      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "stickTableCols", "settings"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("shop-stock-orders-in", [
        "stockInsTypeSelected",
        "shopSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stockInsTypeSelected":
                this.stockInsTypeSelected = selected.value;
                break;
              case "shopSelected":
                this.shopSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  data: () => ({
    stockInsKeyWord: "",
    materialCode: "",
    KeyWord: "",
    stockInsTypeSelected: null,
    stock_ins: [],
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
    currentItemMode: null,
    currentItem: null,
    detailMode: false,
    error_order_id: [],
    excelStockFile: null,
    stockDialog: false,
    shopSelected: null,
    shop_id: null,
  }),

  methods: {
    resetSearch() {
      this.stockInsTypeSelected = null;
      this.shopSelected = null;
      //重置options
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      //重置搜索框
      let clearArr = [
        this.$refs.stock_order_code,
        this.$refs.keyword,
        this.$refs.material_code,
      ];
      clearArr.forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        stock_order_code: this.stockInsKeyWord,
        material_code: this.materialCode,
        keyword: this.KeyWord,
      });
    },
    getStockInsFromAPI() {
      let options = JSON.parse(JSON.stringify(this.options));
      Shops.shopStockOrdersIn(
        Object.assign({}, options, { shop_id: this.shop_id })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_ins = response.data.stock_ins;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    exportExcel() {
      let options = JSON.parse(JSON.stringify(this.options));
      Shops.shopStockOrdersInExport(
        Object.assign({}, options, { shop_id: this.shop_id })
      );
    },
    // doPrint(mode) {
    // var options = JSON.parse(JSON.stringify(this.options));
    // options.page = 1;
    // options.itemsPerPage = this.$consts.limitAll;
    // switch (mode) {
    //   case "stockOrdersInPrint":
    //     this.$router.push({
    //       path: "/print/stock-orders-in-print",
    //       query: options,
    //     });
    //     break;
    // }
    // },
  },

  watch: {
    // $route: {
    //   immediate: true,
    //   handler() {
    //     this.$commonUtils.loadOptions(getOptionPrefix(), getOptionSelects()).then(
    //       function (data) {
    //         if (data.options) {
    //           this.options = data.options;
    //         } else this.resetSearch();
    //
    //         data.selecteds.forEach((selected) => {
    //           switch (selected.key) {
    //             case "stockInsTypeSelected":
    //               this.stockInsTypeSelected = selected.value;
    //               break;
    //           }
    //         });
    //       }.bind(this)
    //     );
    //   }
    // },
    options: {
      deep: true,
      handler() {
        if (this.shopSelected) {
          this.getStockInsFromAPI();
          sessionStorage.setItem(
            "shop-stock-orders-in-options",
            JSON.stringify(this.options)
          );
        }
      },
    },
    shopSelected: {
      handler() {
        this.shop_id = this.shopSelected ? this.shopSelected.id : null;
        if (this.shopSelected) {
          this.getStockInsFromAPI();
        } else {
          this.paging = [];
          this.stock_ins = [];
          this.shopSelected = null;
        }
        sessionStorage.setItem(
          "shop-stock-orders-in-shopSelected",
          JSON.stringify(this.shopSelected)
        );
      },
    },
    stockInsTypeSelected: {
      handler() {
        if (this.stockInsTypeSelected != 11) {
          this.options.keyword = "";
        }
        this.options.type = this.stockInsTypeSelected
          ? this.stockInsTypeSelected
          : "";
        sessionStorage.setItem(
          "shop-stock-orders-in-stockInsTypeSelected",
          JSON.stringify(this.stockInsTypeSelected)
        );
      },
    },
  },
};
</script>